import { combineReducers } from 'redux';
import surveyByEmailReducer from './surveyByEmail';
import surveysReducer from './surveys';

export default combineReducers({
  surveyByEmail: surveyByEmailReducer,
  surveys: surveysReducer,
});
